import { useEffect, useState } from 'react';

/**
 * Holds a value still for `delay` ms. Used on search inputs so a query
 * fires once the operator stops typing rather than on every keystroke.
 */
export function useDebounced<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = window.setTimeout(() => setDebounced(value), delay);
    return () => window.clearTimeout(id);
  }, [value, delay]);
  return debounced;
}
